<template>
  <div>
    <div class="mb-12">
      <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
        <div class="d-flex" style="gap: 24px">
          <div>
            <v-img :src="require('@/assets/mhesr.png')" min-width="100" max-width="100" aspect-ratio="1"></v-img>
          </div>

          <div>
            <div class="page-title">สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)
              <span>
                <Button v-if="currentStep == 1 || currentStep == 2 || currentStep == 3" theme="4" min-width="120px"
                  :disabled="isLoading" @onClick="autoField(currentStep)">
                  autoField - step {{ currentStep }}
                </Button>
              </span>
            </div>
          </div>
        </div>

        <div class="budget-tag">
          <div>ปี งปม.</div>
          <div>
            {{ year }}
          </div>
        </div>
      </divcard>
      <StatusStep :current-step="currentStep" :steps="documentSteps" @onClick="jumpStep"></StatusStep>
    </div>

    <div>
      <step1 v-if="currentStep === 1" :masterData="masterData" :formData="spiderChart1"></step1>
      <step2 v-if="currentStep === 2" :masterData="masterData" :formData="spiderChart2"></step2>
      <step3 v-if="currentStep === 3" :masterData="masterData" :formData="spiderChart3"></step3>
      <preview v-if="currentStep === 4"></preview>
    </div>

    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="cancelled">ยกเลิก</Button>
      <div class="flex-center">
        <div v-if="currentStep == 1"></div>
        <div v-else>
          <Button theme="3" min-width="120px" :masterData="masterData" @onClick="backForm" :disabled="isLoading">&lt;
            ย้อนกลับ</Button>
        </div>

        <Button theme="4" min-width="120px" :masterData="masterData" :disabled="isLoading"
          @onClick="saveDraft(true)">บันทึกฉบับร่าง</Button>
        <Button v-if="currentStep == 4" :theme="validate('one_one') &&
            validate('one_two') &&
            validate('one_three') &&
            validate('one_four') &&
            validate('one_five') &&
            validate('one_six') &&
            validate('one_seven') &&
            validate('two_one') &&
            validate('two_two') &&
            validate('two_three') &&
            validate('two_four') &&
            validate('two_five')
            ? '1'
            : '2'
          " min-width="120px" @onClick="submitForm" :disabled="validate('one_one') &&
              validate('one_two') &&
              validate('one_three') &&
              validate('one_four') &&
              validate('one_five') &&
              validate('one_six') &&
              validate('one_seven') &&
              validate('two_one') &&
              validate('two_two') &&
              validate('two_three') &&
              validate('two_four') &&
              validate('two_five')
              ? false
              : true
            ">ยื่นแบบฟอร์ม</Button>
        <Button v-else theme="3" min-width="120px" :disabled="isLoading" :masterData="masterData"
          @onClick="nextForm">ถัดไป</Button>
      </div>
    </div>
  </div>
</template>

<script>
import StatusStep from "@/components/StatusStep";
import step1 from "./SpiderChart1.vue";
import step2 from "./SpiderChart2.vue";
import step3 from "./SpiderChart3.vue";
import preview from "./SpiderChartPreview.vue";
import Button from "@/components/input/Button";
import { eventBus, validateEmail } from "@/plugins/global-funcs";
import { mapState } from "vuex";
import SpiderChart from "./spiderChart.vue";

export default {
  name: "SpiderChartForm",
  components: {
    step1,
    step2,
    step3,
    StatusStep,
    Button,
    preview,
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.General.isLoading,
    }),
  },
  data() {
    return {
      validateForm: {},
      year: "",
      spiderChart1: {},
      spiderChart2: {},
      spiderChart3: [],
      masterData: {},
      currentStep: 1,
      documentSteps: [
        {
          name: "ข้อมูลบริษัท",
          no: 1,
        },
        {
          name: "รายละเอียด",
          no: 2,
        },
        {
          name: "กิจกรรม",
          no: 3,
        },
      ],
    };
  },
  created() {
    this.getData();
    if (this.$route.params.id) {
      this.retrieveForms();
    }
    eventBus.$on("spiderChart1Send", (form) => {
      this.spiderChart1 = form;
      console.info("1 data: ", this.spiderChart1);
    });
    eventBus.$on("spiderChart2Send", (form) => {
      this.spiderChart2 = form;
      console.info("2 data: ", this.spiderChart2);
    });
    eventBus.$on("spiderChart3Send", (form) => {
      this.spiderChart3 = form;
      console.info("3 data: ", this.spiderChart3);
    });
  },
  watch: {
    currentStep(newValue, oldValue) {
      console.info("currentStep: ", newValue, oldValue);
      if (newValue < oldValue) {
        this.retrieveForms();
      }
      if (newValue == 4) {
        this.retrieveForms();
      }
    },
  },
  methods: {
    validate(section) {
      let isCorrect = true;
      switch (section) {
        case "one_one":
          if (
            !this.validateForm?.spider_chart_1?.company_name_th ||
            !this.validateForm?.spider_chart_1?.company_name_en ||
            !this.validateForm?.spider_chart_1?.company_address ||
            !this.validateForm?.spider_chart_1?.company_postal_code ||
            !this.validateForm?.spider_chart_1?.company_phone ||
            !this.validateForm?.spider_chart_1?.company_fac ||
            !this.validateForm?.spider_chart_1?.company_email ||
            !this.validateForm?.spider_chart_1?.company_website
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "one_two":
          if (!(this.validateForm?.spider_chart_1?.attachments.length > 0)) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_three":
          if (this.validateForm?.area_form_id == null) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_four":
          if (
            !this.validateForm?.spider_chart_1?.space_needed ||
            !this.validateForm?.spider_chart_1?.space_floor ||
            !this.validateForm?.spider_chart_1?.space_room ||
            !this.validateForm?.spider_chart_1?.space_area_size
          ) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_five":
          if (!this.validateForm?.spider_chart_1?.space_type) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_six":
          if (!this.validateForm?.spider_chart_1?.number_of_person) {
            isCorrect = false;
          }
          return isCorrect;
        case "one_seven":
          if (!this.validateForm?.spider_chart_1?.area_type_id) {
            isCorrect = false;
          }
          return isCorrect;

        //part two
        case "two_one":
          if (
            this.validateForm?.spider_chart_2?.spider_chart_2_1?.length === 0
          ) {
            isCorrect = false;
          } else {
            isCorrect = !this.validateForm.spider_chart_2.spider_chart_2_1.some(
              (item) =>
                !item.product_name ||
                item.attachment?.length === 0 ||
                !item.attachment
            );
          }
          return isCorrect;
        case "two_two":
          if (!this.validateForm.spider_chart_2?.activity) {
            isCorrect = false;
          }
          return isCorrect;

        case "two_three":
          if (
            this.validateForm.spider_chart_2?.spider_chart_2_3?.length === 0
          ) {
            isCorrect = false;
          } else {
            isCorrect = !this.validateForm.spider_chart_2.spider_chart_2_3.some(
              (item) => !item.service_type || !item.service_price
            );
          }
          return isCorrect;
        case "two_four":
          if (!this.validateForm?.spider_chart_2?.financial_stability) {
            isCorrect = false;
          }
          return isCorrect;
        case "two_five":
          if (!this.validateForm?.spider_chart_2?.past_cooperation) {
            isCorrect = false;
          }
          return isCorrect;
        default:
          return isCorrect;
      }
    },
    retrieveForms() {
      // Retrieve the form data
      this.$apiFire("Request/getSpiderChartById", {
        id: this.draftId ?? this.$route.params.id,
      }).then((res) => {
        console.info("getSpiderChartById: ", res);
        if (res) {
          console.log("test res", res.data);
          this.spiderChart1 = res.data?.spider_chart_1;
          this.spiderChart2 = res.data?.spider_chart_2 || {};
          this.spiderChart3 = {
            spider_chart_3: res.data?.spider_chart_3 || [],
          };
          if (res?.master_data) {
            this.masterData = res.master_data;
          }
          this.validateForm = res.data;
          this.draftId = res.data.id;
          this.year = res.data?.area_form?.year;
        }
      });
    },
    async getData() {
      const id = this.$route.query.areaID;
      if (id) {
        let res = await this.$apiFire(`Request/getSpiderChartPrepareData`, id);
        this.masterData = res.master_data;
        this.spiderChart1 = {
          company_name_th: res.area_form?.area_form_2?.company_name_th,
          company_name_en: res.area_form?.area_form_2?.company_name_eng,
          company_address: res.area_form?.area_form_2?.headquarters_address,
          company_postal_code:
            res.area_form?.area_form_2?.headquarters_postal_code,
          company_phone: res.area_form?.area_form_2?.headquarters_phone,
          company_fac: res.area_form?.area_form_2?.headquarters_fac,
          company_email: res.area_form?.area_form_2?.headquarters_email,
          company_website: res.area_form?.area_form_2?.headquarters_website,
        };
        this.year = res.area_form?.year;
      }
    },
    async nextForm() {
      if (this.currentStep >= this.documentSteps.length) {
        const res = await this.saveDraft();
        this.currentStep = 4;
        // if (res) {
        //   return this.$router.push({
        //     name: "spiderChartPreview",
        //     params: { id: this.draftId },
        //   });
        // }
      } else {
        const res2 = await this.saveDraft();
        if (res2) {
          this.currentStep += 1;
          // router replace เติม query ไปด้วย
          if (this.draftId) {
            return this.$router.push(
              "/space-requests-management/spider-chart-form/" +
              this.draftId +
              "?areaID=" +
              this.$route.query.areaID
            );
          }
          this.$vuetify.goTo("#app");
        }
      }
    },
    backForm() {
      if (this.currentStep <= 1) return;
      const res = this.saveDraft();
      if (res) {
        this.currentStep -= 1;
        // ถ้ามี draftId แล้ว ให้ push route ไปที่ edit
        if (this.draftId) {
          return this.$router.push(
            "/space-requests-management/spider-chart-form/" +
            this.draftId +
            "?areaID=" +
            this.$route.query.areaID
          );
        }
        this.$vuetify.goTo("#app");
      }
    },
    requestForm(formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit("spiderChart1");
          break;

        case 2:
          eventBus.$emit("spiderChart2");
          break;

        case 3:
          eventBus.$emit("spiderChart3");
          break;
      }
    },
    async saveDraft(goToList = false) {
      this.requestForm(this.currentStep);
      // validate formGeneral
      // if (this.currentStep == 1) {
      //   if (!this.spiderChart1?.company_name_th) {
      //     this.$store.commit("General/setModal", {
      //       title: "ข้อมูลไม่ถูกต้อง",
      //       text: "กรุณากรอกข้อมูลให้ถูกต้อง",
      //       theme: "error",
      //       showCancel: false,
      //       buttonText: "OK",
      //     });
      //     return false;
      //   }
      // }

      let payload = {
        ...(this.spiderChart3 ? this.spiderChart3 : []),
        spider_chart_1: { ...this.spiderChart1 },
        ...(Object.keys(this.spiderChart2).length > 0 && {
          spider_chart_2: { ...this.spiderChart2 },
        }),
        area_form_id: parseInt(this.$route.query.areaID),
        status: "Draft",
      };

      if (payload?.spider_chart_1?.attachments?.length > 0) {
        console.log("payload: ", payload);
        let uploadPromises = payload?.spider_chart_1?.attachments?.map(
          (attachment, index) => {
            if (attachment instanceof File) {
              return this.uploadFile(attachment).then((result) => {
                console.log("file ", index, "is uploaded");
                return result;
              });
            } else {
              return Promise.resolve(attachment);
            }
          }
        );
        payload.spider_chart_1.attachments = await Promise.all(uploadPromises);
      }
      if (payload?.spider_chart_2?.spider_chart_2_1?.length > 0) {
        let uploadPromises = payload.spider_chart_2.spider_chart_2_1.map(
          async (item, index) => {
            if (item?.attachment instanceof File) {
              try {
                const uploadedFile = await this.uploadFile(item.attachment);
                console.log("File at index", index, "is uploaded");
                // Update the attachment with the uploaded file data
                return {
                  ...item,
                  attachment: uploadedFile,
                };
              } catch (error) {
                console.error(
                  "Error uploading file at index",
                  index,
                  ":",
                  error
                );
                throw error; // Propagate error if needed
              }
            } else {
              // Retain existing attachment if not a File instance
              return item;
            }
          }
        );

        try {
          payload.spider_chart_2.spider_chart_2_1 = await Promise.all(
            uploadPromises
          );
        } catch (error) {
          console.error("Error processing spider_chart_2_1:", error);
        }
      }

      // Add the ID to the payload if it exists
      if (this.draftId) {
        payload.id = this.draftId;
      }

      console.info("payload: ", payload);
      let res = null;
      // Check if the form has an ID
      if (payload.id) {
        try {
          console.info("update draft");
          res = await this.updateDraft(payload);
        } catch (error) {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: "OK",
          });
          return;
        }
      } else {
        try {
          console.info("save draft");
          res = await this.$apiFire("Request/storeSpiderChart", payload);
          // Update the form's ID after saving
          this.draftId = res.id;
        } catch (error) {
          this.$store.commit("General/setModal", {
            title: "Error",
            text: error.message,
            theme: "error",
            showCancel: false,
            buttonText: "OK",
          });
          return;
        }
      }
      if (goToList) {
        this.$router.push({ name: "spaceRequestsOffer" });
      }
      this.retrieveForms();

      // eslint-disable-next-line no-prototype-builtins
      return typeof res === "object" && res.hasOwnProperty("id");
    },
    async uploadFile(file) {
      try {
        let formData = new FormData();
        formData.append("files[]", file);
        let payload = {
          files: formData,
        };
        let res = await this.$apiFire("Attachment/uploadFile", formData);
        if (res.length > 0) {
          return res[0];
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    },
    async updateDraft(payload) {
      let res = await this.$apiFire("Request/updateSpiderChart", payload);
      console.info(res);
      return res;
    },
    jumpStep(step) {
      if (step == this.currentStep) return;
      if (this.isLoading) {
        this.$store.commit("General/setModal", {
          title: "Wait a moment.",
          text: "Preparing data please wait...",
          theme: "warning",
          showCancel: false,
          buttonText: "OK",
        });
        return;
      }
      if (this.$route.params.id) {
        this.currentStep = parseInt(step);
        this.$vuetify.goTo("#app");
        this.doNotSubmit = false;
      } else {
        alert(this.$route.params.id);
        this.$store.commit("General/setModal", {
          title: "Complete this step first!",
          text: "Complete the first step then you can jump",
          theme: "error",
          showCancel: false,
          buttonText: "OK",
        });
      }
    },
    cancelled() {
      this.$router.push("/space-requests-management/space-requests-offer");
    },
    submitForm() {
      if (
        this.validate("one") &&
        this.validate("two") &&
        this.validate("three")
      ) {
        this.$apiFire("Request/updateSpiderChart", {
          id: this.$route.params.id,
          status: "Submitted",
        })
          .then((res) => {
            if (res) {
              this.$router.push({ name: "spaceRequestsOffer" });
            }
          })
          .catch((error) => {
            this.$store.commit("General/setModal", {
              title: "Error",
              text: error.message,
              theme: "error",
              showCancel: false,
              buttonText: "OK",
            });
            return;
          });
      }
    },
    autoField(step) {
      if (step === 1) {
        const mapData1 = {
          // ข้อมูลบริษัท
          company_name_th: "ตัวอย่างชื่อบริษัท (ภาษาไทย)",
          company_name_en: "ตัวอย่างชื่อบริษัท (ภาษาอังกฤษ)",
          company_address: "123/4 ถนนสุขุมวิท แขวงคลองเตย กรุงเทพฯ",
          company_postal_code: "10110",
          company_phone: "021234567",
          company_fac: "021234568",
          company_email: "example@example.com",
          company_website: "https://www.example.com",

          // ความต้องการใช้พื้นที่
          space_needed:
            "ตัวอย่าง พื้นที่อำนวยความสะดวกเพื่อสนับสนุนระบบนิเวศอุทยานฯ (Ecosystem Supporting Facility)",
          space_floor: "ชั้น 1",
          space_room: "A101",
          space_area_size: "100.00",
          space_type: "จัดตั้งเป็นสำนักงาน",
          space_type_other: "ตัวอย่างประเภทพื้นที่อื่น ๆ",

          // จำนวนบุคคล
          number_of_person: "10",

          // ประเภทผู้ใช้บริการพื้นที่
          area_type_id: 1,

          // attachments: [
          //   {
          //     file_name: "example.pdf",
          //     file_path: "/uploads",
          //     file_extension: "pdf",
          //     full_path: "/uploads/example.pdf",
          //   },
          // ],
        };
        this.spiderChart1 = { ...this.spiderChart1, ...mapData1 };
        this.$nextTick(() => {
          this.$emit("spiderChart1Send", this.spiderChart1);
        });
      } else if (step == 2) {
        const mapStep2 = {
          spider_chart_2_1: [
            {
              isNew: true,
              attachment: [{
                file_name: null,
              }],
              product_name: "ตัวอย่างผลิตภัณฑ์ 1",
            },
              {
              isNew: true,
              attachment: [{
                file_name: null,
              }],
              product_name: "ตัวอย่างผลิตภัณฑ์ 2",
            },
              {
              isNew: true,
              attachment: [{
                file_name: null,
              }],
              product_name: "ตัวอย่างผลิตภัณฑ์ 3",
            },
          ],
          spider_chart_2_3: [
            {
              service_type: "ตัวอย่างประเภทบริการ 1",
              service_price: "100",
            },
            {
              service_type: "ตัวอย่างประเภทบริการ 2",
              service_price: "200",
            },
            {
              service_type: "ตัวอย่างประเภทบริการ 3",
              service_price: "300",
            },
          ],
          activity: "ตัวอย่างกิจกรรมที่จะเกิดขึ้นภายในอาคาร",
          financial_stability: "ตัวอย่างเสถียรภาพทางการเงิน",
          past_cooperation: "ตัวอย่างความร่วมมือที่ผ่านมา",
        }
        this.spiderChart2 = { ...this.spiderChart2, ...mapStep2 };
        this.$nextTick(() => {
          this.$emit("spiderChart2Send", this.spiderChart2);
        });
      } else if (step == 3) {
        const mapStep3 = {
          spider_chart_3: [
              {
                isNew: true,
                source_topical: ["สำนักงบประมาณ"],
                year: "1",
                name: "โครงการ 1",
                plan: "ตัวอย่างแผนการดำเนินงาน 1",
                budget: "100",
                duration: "10 วัน",
              },
                {
                isNew: true,
                source_topical: ["สำนักงบประมาณ"],
                year: "2",
                name: "โครงการ 2",
                plan: "ตัวอย่างแผนการดำเนินงาน 2",
                budget: "200",
                duration: "20 วัน",
              },
                {
                isNew: true,
                source_topical: ["สำนักงบประมาณ"],
                year: "3",
                name: "โครงการ 3",
                plan: "ตัวอย่างแผนการดำเนินงาน 3",
                budget: "300",
                duration: "30 วัน",
              },
            ],
        }
        this.spiderChart3 = { ...this.spiderChart3, ...mapStep3 };
        this.$nextTick(() => {
          this.$emit("spiderChart3Send", this.spiderChart3);
        });
      }
    },
  },
  beforeDestroy() {
    eventBus.$off("spiderChart1Send");
    eventBus.$off("spiderChart2Send");
    eventBus.$off("spiderChart3Send");
  },
};
</script>

<style></style>
